// extracted by mini-css-extract-plugin
export var contentBody = "_6p-9";
export var headerImage = "_6p-2";
export var imageButton = "_6p-7";
export var imageButtonIcon = "_6p-8";
export var imageHeader = "_6p-4";
export var imageHeaderText = "_6p-5";
export var imageOverlay = "_6p-3";
export var imageTitle = "_6p-6";
export var imageWrapper = "_6p-1";
export var taskList = "_6p-a";
export var widget = "_6p-0";